import instance from "./api";
import { AxiosResponse } from "axios";
import { IFinance } from "../helpers/types";

export default class FinanceService {
    static async findAll(params: any): Promise<AxiosResponse<any>> {
        return instance.get("finance/", {
            params
        });
    }

    static async findOne(id: number): Promise<AxiosResponse<IFinance>> {
        return instance.get<IFinance>(`finance/${id}`);
    }

    static async create(finance: any): Promise<AxiosResponse<IFinance>> {
        return instance.post<IFinance>("finance/", finance);
    }

    static async update(id: number, finance: any): Promise<AxiosResponse<IFinance>> {
        return instance.put<IFinance>(`finance/${id}`, finance);
    }

    static async delete(id: number): Promise<AxiosResponse<IFinance>> {
        return instance.delete<IFinance>(`finance/${id}`);
    }

    static async getStats(params: any): Promise<AxiosResponse<any>> {
        return instance.get("finance/stats", {
            params
        });
    }

    static async getDailyDealsCount(period: 'month' | 'year' = 'month', year?: number, month?: number): Promise<AxiosResponse<any>> {
        return instance.get("finance/stats/daily-count", { params: { period, year, month } });
    }

    static async getAvailableYears(): Promise<AxiosResponse<number[]>> {
        return instance.get("finance/stats/years");
    }

}
